import { Injectable } from '@angular/core';
import { ApiService, ApiCacheOptions, PagedSearch } from '../../../shared/index'; //app/shared/index barrel;
import { PagedResult } from '../../../shared/model/generic-paged-result.model';

import { IFormBuilder } from './iform-builder.service';
import { ValueTypeEnum } from '../model/value-type-enum.model';
import { FormElementType } from '../model/form-element-type.model';
import { FormTemplate } from '../model/form-template.model';
import { FormGroup } from '../model/form-group.model';
import { FormSearch } from '../model/form-search.model';

@Injectable()
export class FormBuilder implements IFormBuilder {
  private _apiService: ApiService;
  private _cacheOptions: ApiCacheOptions;

  public constructor(apiService: ApiService) {
    this._apiService = apiService;

    //this._cacheOptions = new ApiCacheOptions();
    //this._cacheOptions.DisableCaching = true;
  }

  public getForm = (id: number): Promise<FormTemplate> => {
    var url = 'Forms/JoinForm/Template/' + id.toString();
    return this._apiService.get(url);
  };

  public searchForms = (params: FormSearch = new FormSearch()): Promise<PagedResult<Array<FormTemplate>>> => {
    var url = 'Forms/Templates/';
    return this._apiService.getPaged(url, params);
  };

  public createForm = (formTemplate: FormTemplate): Promise<number> => {
    var url = '/Forms/Templates';
    return this._apiService.post(url, formTemplate);
  };

  public updateForm = (formTemplate: FormTemplate): Promise<void> => {
    var url = '/Forms/Template/' + formTemplate.Id.toString();
    return this._apiService.put(url, formTemplate);
  };

  public deleteForm = (id: number): Promise<void> => {
    var url = '/Forms/Template/' + id.toString();
    return this._apiService.delete(url);
  };
}
